import React, { useState } from "react";
import { useQuery, useMutation } from "react-query";
import firebase from "firebase";
import Button from "../../components/Button";
import { nanoid } from "nanoid";
import Modal from "react-modal";
import { Formik, Field, Form } from "formik";
import styled from "styled-components";
import "react-datepicker/dist/react-datepicker.css";
Modal.setAppElement(document.body);

const FormGroup = styled.div``;

type FirebaseAdmin = {
  email: string;
  name: string;
  username: string;
  isTeacher: boolean;
  isSuperuser: boolean;
};

const Administrators = () => {
  const [isShowingModal, showModal] = useState(false);
  const { isLoading, error, data } = useQuery<FirebaseAdmin[]>(
    "administrators",
    () =>
      firebase
        .firestore()
        .collection("administrators")
        .get()
        .then((snapshot) => {
          const admins: FirebaseAdmin[] = [];
          snapshot.forEach((doc) => {
            const data = doc.data() as FirebaseAdmin;
            admins.push(data);
          });
          return admins;
        })
  );

  const { mutate: addAdminToFirebase } = useMutation(
    "administrators",
    async (variables: FirebaseAdmin) => {
      const newAccount = await firebase
        .auth()
        .createUserWithEmailAndPassword(variables.email, nanoid());

      await firebase.auth().sendPasswordResetEmail(variables.email);
      await firebase
        .firestore()
        .collection("administrators")
        .doc(newAccount.user?.uid || "")
        .set(variables);
      return variables;
    }
  );

  if (isLoading) {
    return <div>Loading</div>;
  }

  if (error) {
    return <div>ERROR: {JSON.stringify(error)}</div>;
  }

  return (
    <div>
      <Button onClick={() => showModal(true)}>Add new admin</Button>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Username</th>
            <th>Email</th>
            <th>Is Superuser?</th>
            <th>Is Teacher?</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {data?.map((admin) => (
            <tr>
              <td>TBA</td>
              <td>{admin.name}</td>
              <td>{admin.username}</td>
              <td>{admin.email}</td>
              <td>{admin.isSuperuser ? "Yes" : "No"}</td>
              <td>{admin.isTeacher ? "Yes" : "No"}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <Modal isOpen={isShowingModal} onRequestClose={() => showModal(false)}>
        <Formik
          initialValues={{
            name: "",
            username: "",
            email: "",
            isSuperuser: false,
            isTeacher: true,
          }}
          onSubmit={(values: FirebaseAdmin) => {
            setTimeout(() => {
              addAdminToFirebase(values);
              showModal(false);
            }, 500);
          }}
        >
          <Form>
            <FormGroup>
              <label htmlFor="name">Name</label>
              <Field id="name" name="name" placeholder="Name" />
            </FormGroup>
            <FormGroup>
              <label htmlFor="username">Username</label>
              <Field id="username" name="username" placeholder="username" />
            </FormGroup>
            <FormGroup>
              <label htmlFor="email">Email</label>
              <Field id="email" name="email" placeholder="email" />
            </FormGroup>

            <FormGroup>
              <label htmlFor="stars">User type</label>
              <Field type="checkbox" name="isTeacher" /> Teacher
              <Field type="checkbox" name="isSuperuser" /> Superuser
            </FormGroup>

            <FormGroup>
              <button type="submit">Submit</button>
            </FormGroup>
          </Form>
        </Formik>
      </Modal>
    </div>
  );
};

export default Administrators;
